import React from 'react'
import styled from 'styled-components'
import { Button, ButtonColor, ButtonVariant } from 'lib/Button/Button'

const StyledButton = styled(Button)`
  min-width: 96px;
`

interface Props {
  children: React.ReactNode
  className?: string
  color?: ButtonColor
  disabled?: boolean
  form?: string
  loading?: boolean
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void
  type?: 'button' | 'submit'
  variant?: ButtonVariant
}
export const SubmitButton = ({ children, className, color = 'primary', disabled, form, loading, onClick, type = 'submit', variant }: Props) => (
  <StyledButton
    className={className}
    color={color}
    disabled={disabled || loading}
    form={form}
    label={children}
    loading={loading}
    onClick={onClick}
    type={type}
    variant={variant}
  />
)
